import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'

import { CircularProgress } from 'shared/components/circularProgress'

import { TranslationKeys } from './enums/TranslationKeys'

export const baseColumns = [
  {
    field: 'PartnerID',
    title: TranslationKeys.columnPartnerId,
    priority: 1,
  },
  {
    field: 'LocationID',
    title: TranslationKeys.columnLocationId,
    priority: 2,
  },
  {
    field: 'CommunicationName',
    title: TranslationKeys.columnPartnerName,
    priority: 3,
  },
  {
    field: 'GeoMarket',
    title: TranslationKeys.columnMarket,
    priority: 4,
  },
  {
    field: `Country`,
    title: TranslationKeys.columnCountry,
    priority: 5,
  },
  {
    field: `Plan360Completeness`,
    title: TranslationKeys.columnCompletion,
    priority: 6,
    renderFunction: (item: IWWPartners) => {
      return (
        <CircularProgress
          percent={Number(item.Plan360Completeness)}
          radius={20}
          isShowCompletedIcon={Boolean(item.IsAcknowledged)}
        />
      )
    },
  },
  {
    field: `HierarchyType`,
    title: TranslationKeys.columnHierarchy,
    priority: 7,
  },
]
